App.module('BbSearchApp', function(BbSearchApp, App, Backbone, Marionette){
    'use strict';

    BbSearchApp.Router = Marionette.AppRouter.extend({
        appRoutes: {
            'search(/:phrase)': 'searchPhrase'
        }
    });

    var API = {
        searchPhrase: function(phrase){
            BbSearchApp.searchPhrase = phrase;
        }
    };

    
    App.on('start', function(){
        if(typeof BbSearchApp.BbSearch.SearchPageForm !== 'undefined') {
            BbSearchApp.isSearchPage = true;
        } else {
            BbSearchApp.isSearchPage = false;
        }

        var controller = new BbSearchApp.BbSearch.Controller();
        App.on('bbsearch:term', function(searchTerms){
            controller.searchPhrase(searchTerms);
            App.navigate('search/' + searchTerms);
        });
        App.on('bbsearch:page:term', function(searchTerms){
            controller.searchPhrase(searchTerms, 0, true);
        });
        if (BbSearchApp.searchPhrase){
            if(BbSearchApp.isSearchPage) {
                App.trigger('bbsearch:page:term', BbSearchApp.searchPhrase);
                App.trigger('bbsearch:page:start', BbSearchApp.searchPhrase);
            } else {
                App.trigger('bbsearch:term', BbSearchApp.searchPhrase);
            }
            App.trigger('bbsearch:initialize', BbSearchApp.searchPhrase);
        }
    });
    
    App.addInitializer(function(){
        new BbSearchApp.Router({
            controller: API
        });
    });

});